var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isEnabled
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "content",
                style: {
                  height: Number.isInteger(_vm.height)
                    ? _vm.height + "px"
                    : _vm.height,
                },
              },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            !_vm.isReadingMore
              ? _c(
                  "a",
                  {
                    attrs: { href: "javascript:" },
                    on: { click: _vm.readMore },
                  },
                  [_vm._v("read more")]
                )
              : _c(
                  "a",
                  {
                    attrs: { href: "javascript:" },
                    on: { click: _vm.readLess },
                  },
                  [_vm._v("read less")]
                ),
          ])
        : _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }